/**
 * Seed & Xeria Bands - Instant Luxury Buy Button Handler
 * - Handles reference pill button (".seed-ref-buy-btn") clicks.
 * - Adds item directly to Shopify cart via AJAX (POST /cart/add.js).
 * - Instant micro-interaction feedback (checkmark + "Agregado" state).
 * - Updates cart counter in the header & triggers cart events.
 * - Reverts back to "Comprar" smoothly after 1.6 seconds.
 */

(function () {
  'use strict';

  function addToCart(vId, btn) {
    const rootUrl =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(vId, 10),
        quantity: 1
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(() => {
        return fetch(rootUrl + 'cart.js');
      })
      .then((res) => res.json())
      .then((cart) => {
        document.querySelectorAll('#SeedCartCount, .seed-cart-count-badge, .seed-cart-count, [data-cart-count]').forEach((badge) => {
          badge.textContent = cart.item_count;
        });
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'seed-ref-buy-btn',
            cartId: cart.id
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'seed-ref-buy-btn' } }));
      })
      .catch((err) => {
        console.warn('Cart add error:', err);
      });
  }

  // Delegated click handler for maximum performance and instant compatibility with dynamic cards
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.seed-ref-buy-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

    const variantId = btn.dataset.variantId;
    const productUrl = btn.dataset.productUrl;

    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    // Success micro-interaction
    btn.classList.add('is-success');
    const originalContent = btn.innerHTML;
    btn.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; vertical-align:-2px; margin-right:4px;">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>Agregado</span>
    `;

    addToCart(variantId, btn);

    setTimeout(() => {
      btn.classList.remove('is-success');
      btn.innerHTML = originalContent;
    }, 1600);
  });

  /* ==========================================================================
     CARD DUAL PILL: Size Selector & Add to Cart
     ========================================================================== */

  // 1. Toggle Size Popover
  document.addEventListener('click', function (e) {
    const sizeBtn = e.target.closest('.seed-card-size-btn');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();

      const picker = sizeBtn.closest('.seed-card-size-picker');
      if (!picker) return;

      const isOpen = picker.classList.contains('is-open');

      // Close any other open popovers
      document.querySelectorAll('.seed-card-size-picker.is-open').forEach((p) => {
        if (p !== picker) {
          p.classList.remove('is-open');
          const btn = p.querySelector('.seed-card-size-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          const card = p.closest('.card-wrapper, .seed-product-card');
          if (card) card.classList.remove('is-popover-open');
        }
      });

      // Toggle this picker
      picker.classList.toggle('is-open', !isOpen);
      sizeBtn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      const card = picker.closest('.card-wrapper, .seed-product-card');
      if (card) {
        card.classList.toggle('is-popover-open', !isOpen);
      }
      return;
    }

    // 2. Select Size Option
    const opt = e.target.closest('.seed-card-size-opt');
    if (opt) {
      e.preventDefault();
      e.stopPropagation();

      if (opt.classList.contains('is-disabled') || opt.disabled) return;

      const picker = opt.closest('.seed-card-size-picker');
      const box = opt.closest('.seed-card-footer-box');
      if (!picker || !box) return;

      const variantId = opt.dataset.variantId;
      const variantTitle = opt.dataset.variantTitle || '';
      const variantPrice = opt.dataset.variantPrice;
      const variantComparePrice = opt.dataset.variantComparePrice;

      // Update active option style
      picker.querySelectorAll('.seed-card-size-opt').forEach((o) => {
        o.classList.remove('is-selected');
        const check = o.querySelector('.seed-card-opt-check');
        if (check) check.remove();
      });
      opt.classList.add('is-selected');
      const statusSpan = opt.querySelector('.seed-card-opt-status');
      if (statusSpan && !statusSpan.querySelector('.seed-card-opt-check')) {
        statusSpan.innerHTML = `
          <svg class="seed-card-opt-check" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"></polyline></svg>
        `;
      }

      // Update button label: extract first word (e.g. "S", "M", "L", "XL")
      const shortLabel = variantTitle.split(' ')[0] || variantTitle;
      const labelSpan = picker.querySelector('.seed-card-size-label');
      if (labelSpan) {
        labelSpan.textContent = shortLabel;
      }

      // Close popover
      picker.classList.remove('is-open');
      const triggerBtn = picker.querySelector('.seed-card-size-btn');
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
      const card = picker.closest('.card-wrapper, .seed-product-card');
      if (card) card.classList.remove('is-popover-open');

      // Update Add to Cart button variant ID
      const addBtn = box.querySelector('.seed-card-add-btn');
      if (addBtn) {
        addBtn.dataset.variantId = variantId;
      }

      // Update Price display in Row 1
      if (variantPrice) {
        const priceSpan = box.querySelector('.seed-card-price');
        if (priceSpan) priceSpan.textContent = variantPrice;
      }
      const compareSpan = box.querySelector('.seed-card-compare-price');
      if (compareSpan) {
        if (variantComparePrice) {
          compareSpan.textContent = variantComparePrice;
          compareSpan.style.display = '';
        } else {
          compareSpan.style.display = 'none';
        }
      }
      return;
    }

    // 3. Click outside closes popovers
    if (!e.target.closest('.seed-card-size-picker')) {
      document.querySelectorAll('.seed-card-size-picker.is-open').forEach((p) => {
        p.classList.remove('is-open');
        const btn = p.querySelector('.seed-card-size-btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        const card = p.closest('.card-wrapper, .seed-product-card');
        if (card) card.classList.remove('is-popover-open');
      });
    }

    // 4. Add to Cart button
    const addBtn = e.target.closest('.seed-card-add-btn');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-success')) return;

      const variantId = addBtn.dataset.variantId;
      const productUrl = addBtn.dataset.productUrl;

      if (!variantId) {
        if (productUrl) window.location.href = productUrl;
        return;
      }

      // Success micro-interaction
      addBtn.classList.add('is-success');
      const originalHtml = addBtn.innerHTML;
      addBtn.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; vertical-align:-1px; margin-right:3px;">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span class="seed-card-add-btn-text">Agregado</span>
      `;

      addToCart(variantId, addBtn);

      setTimeout(() => {
        addBtn.classList.remove('is-success');
        addBtn.innerHTML = originalHtml;
      }, 1500);
      return;
    }
  });

  /* ==========================================================================
     PDP (Product Page) Direct Checkout & State Sync
     ========================================================================== */

  // Handle direct checkout "Comprar" button on Product Detail Page
  document.addEventListener('click', function (e) {
    const buyNowBtn = e.target.closest('.seed-pdp-buy-now-btn');
    if (!buyNowBtn || buyNowBtn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const rootUrl =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const form =
      buyNowBtn.closest('form') ||
      (buyNowBtn.dataset.productFormId ? document.getElementById(buyNowBtn.dataset.productFormId) : null) ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('.product-form form');

    const variantInput = form
      ? form.querySelector('input[name="id"].product-variant-id, input[name="id"]')
      : document.querySelector('input.product-variant-id, input[name="id"]');

    const variantId = variantInput ? variantInput.value : buyNowBtn.dataset.variantId;
    if (!variantId) {
      window.location.href = '/checkout';
      return;
    }

    const qtyInput = form
      ? form.querySelector('input[name="quantity"]')
      : document.querySelector('.product-form__quantity input[name="quantity"], input[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // Visual feedback
    buyNowBtn.disabled = true;
    const textSpan = buyNowBtn.querySelector('.seed-pdp-buy-text');
    if (textSpan) textSpan.textContent = 'Procesando...';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: quantity
      })
    })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/cart/' + variantId + ':' + quantity + '?checkout';
      });
  });

  // Sync "Comprar" state when variant availability changes
  function initPdpSync() {
    const submitBtn = document.querySelector('.product-form__submit');
    const buyNowBtn = document.querySelector('.seed-pdp-buy-now-btn');
    if (submitBtn && buyNowBtn) {
      function syncState() {
        const isSoldOut = submitBtn.disabled;
        buyNowBtn.disabled = isSoldOut;
        const textSpan = buyNowBtn.querySelector('.seed-pdp-buy-text');
        if (textSpan) {
          textSpan.textContent = isSoldOut ? 'Agotado' : 'Comprar';
        }
      }

      syncState();

      if (!submitBtn._obsInit) {
        submitBtn._obsInit = true;
        const observer = new MutationObserver(syncState);
        observer.observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
      }
    }

    // Also align variant-selects and quantity-form as direct siblings for CSS Grid
    const infoContainer = document.querySelector('.product__info-container');
    const variantSelects = infoContainer ? infoContainer.querySelector('variant-selects') : null;
    const qtyForm = infoContainer ? infoContainer.querySelector('.product-form__quantity') : null;
    if (variantSelects && qtyForm && variantSelects.nextElementSibling !== qtyForm) {
      variantSelects.after(qtyForm);
    }

    if (infoContainer && !infoContainer._pdpObserved) {
      infoContainer._pdpObserved = true;
      const mo = new MutationObserver(function () {
        initPdpSync();
      });
      mo.observe(infoContainer, { childList: true });
    }

    // Initialize butter-smooth accordion animations
    initSmoothAccordions();

    // Initialize custom size dropdown (delegated)
    initCustomSizeDropdown();
  }

  // Minimalist Custom Size Dropdown (Using robust Document-Level Event Delegation - Never Breaks on Variant Swap)
  function initCustomSizeDropdown() {
    if (document._xeriaDropdownDelegationInit) return;
    document._xeriaDropdownDelegationInit = true;

    // Delegated click handler for triggers, options, and outside clicks
    document.addEventListener('click', function (e) {
      // 1. Click on custom trigger pill
      const trigger = e.target.closest('.xeria-custom-select-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const container = trigger.closest('.xeria-dropdown-container');
        if (!container) return;

        const isOpen = container.classList.contains('is-open');

        // Close any other open dropdowns
        document.querySelectorAll('.xeria-dropdown-container.is-open').forEach(function (c) {
          if (c !== container) {
            c.classList.remove('is-open');
            const tr = c.querySelector('.xeria-custom-select-trigger');
            if (tr) tr.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          container.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          container.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // 2. Click on dropdown option item
      const item = e.target.closest('.xeria-dropdown-menu-item');
      if (item) {
        e.preventDefault();
        e.stopPropagation();
        if (item.classList.contains('is-disabled')) return;

        const container = item.closest('.xeria-dropdown-container');
        if (!container) return;

        const trig = container.querySelector('.xeria-custom-select-trigger');
        const labelSpan = container.querySelector('.xeria-dropdown-trigger-label');
        const nativeSelect = container.querySelector('.xeria-native-select');
        const val = item.getAttribute('data-value');
        const label = item.getAttribute('data-label');

        // Update trigger label
        if (labelSpan && label) {
          labelSpan.textContent = label;
        }

        // Update active class in menu
        container.querySelectorAll('.xeria-dropdown-menu-item').forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');

        // Close dropdown
        container.classList.remove('is-open');
        if (trig) trig.setAttribute('aria-expanded', 'false');

        // Sync to native select and notify Shopify engine
        if (nativeSelect && nativeSelect.value !== val) {
          nativeSelect.value = val;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // 3. Click outside -> close any open dropdowns
      if (!e.target.closest('.xeria-dropdown-container')) {
        document.querySelectorAll('.xeria-dropdown-container.is-open').forEach(function (c) {
          c.classList.remove('is-open');
          const tr = c.querySelector('.xeria-custom-select-trigger');
          if (tr) tr.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Delegated change handler for native select sync
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('xeria-native-select')) {
        const nativeSelect = e.target;
        const container = nativeSelect.closest('.xeria-dropdown-container');
        if (!container) return;

        const curVal = nativeSelect.value;
        const labelSpan = container.querySelector('.xeria-dropdown-trigger-label');
        const options = container.querySelectorAll('.xeria-dropdown-menu-item');

        options.forEach(function (opt) {
          if (opt.getAttribute('data-value') === curVal) {
            opt.classList.add('is-selected');
            opt.setAttribute('aria-selected', 'true');
            if (labelSpan) {
              labelSpan.textContent = opt.getAttribute('data-label');
            }
          } else {
            opt.classList.remove('is-selected');
            opt.setAttribute('aria-selected', 'false');
          }
        });
      }
    });

    // Escape key closes dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.xeria-dropdown-container.is-open').forEach(function (c) {
          c.classList.remove('is-open');
          const tr = c.querySelector('.xeria-custom-select-trigger');
          if (tr) tr.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // Butter-smooth hardware-accelerated Accordion Animation
  function initSmoothAccordions() {
    const accordions = document.querySelectorAll('.product__accordion details');
    accordions.forEach(function (el) {
      if (el._accordionInit) return;
      el._accordionInit = true;

      const summary = el.querySelector('summary');
      const content = el.querySelector('.accordion__content');
      if (!summary || !content) return;

      let animation = null;
      let isClosing = false;
      let isExpanding = false;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        el.style.overflow = 'hidden';
        const wrapper = el.closest('.product__accordion');

        if (isClosing || !el.open) {
          // OPEN ANIMATION
          if (wrapper) wrapper.classList.add('is-open');
          el.style.height = el.offsetHeight + 'px';
          el.open = true;
          window.requestAnimationFrame(function () {
            isExpanding = true;
            const startHeight = el.offsetHeight + 'px';
            const endHeight = (summary.offsetHeight + content.offsetHeight) + 'px';

            if (animation) animation.cancel();

            animation = el.animate(
              { height: [startHeight, endHeight] },
              { duration: 280, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
            );

            animation.onfinish = function () {
              isExpanding = false;
              animation = null;
              el.style.height = '';
              el.style.overflow = '';
            };
            animation.oncancel = function () {
              isExpanding = false;
            };
          });
        } else if (isExpanding || el.open) {
          // CLOSE ANIMATION
          isClosing = true;
          const startHeight = el.offsetHeight + 'px';
          const endHeight = summary.offsetHeight + 'px';

          if (animation) animation.cancel();

          animation = el.animate(
            { height: [startHeight, endHeight] },
            { duration: 240, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          );

          animation.onfinish = function () {
            el.open = false;
            if (wrapper) wrapper.classList.remove('is-open');
            isClosing = false;
            animation = null;
            el.style.height = '';
            el.style.overflow = '';
          };
          animation.oncancel = function () {
            isClosing = false;
            if (wrapper) wrapper.classList.remove('is-open');
          };
        }
      });
    });
    // Horizontal wheel scrolling for thumbnail carousel on desktop
    const thumbList = document.querySelector('.thumbnail-list');
    if (thumbList) {
      thumbList.addEventListener('wheel', function (e) {
        if (thumbList.scrollWidth > thumbList.clientWidth) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            e.preventDefault();
            thumbList.scrollLeft += e.deltaY;
          }
        }
      }, { passive: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpSync);
  } else {
    initPdpSync();
  }
  document.addEventListener('product-info:loaded', initPdpSync);
  document.addEventListener('shopify:section:load', initPdpSync);
})();
